export const FILTER_KEYS = ["PackageSize",  "EAD", "Cycle", "Cluster", "CPT", "OtherAttributes"]

/**
 * Function that clears the state for keys mentioned in FILTER_KEYS
 * and returns the new state
 * @param state
 * @returns Object
 */
export const removeFilters = (state) => {
    const newState = {...state}
    FILTER_KEYS.forEach(key => {
        const values = state[key];
        if (Array.isArray(values) && values.length) {
            newState[key] = [];
        }
    });
    return newState;
}

/**
 * Function that returns the filter keys that were unselected
 * @param currentSelection
 * @param state
 * @returns Object
 */
export const getRemovedStates = (currentSelection, state) => {
    return FILTER_KEYS.filter(key => !currentSelection.includes(key))
        .filter(key => Array.isArray(state[key]) && state[key].length > 0)
        .reduce((acc, key) => {acc[key] = []; return acc;}, {});
}


// WEBPACK FOOTER //
// ./src/components/util/FilterUtil.js